export default __webpack_public_path__ + "static/media/no-results.c54f5080.webp";